const Socket = {
  // 初始化
  init({ host, userId }, callback) {
    const url = `ws://${host}/jpaas-jdata-server/webSocket/` + userId
    this.WS = new WebSocket(url)
    this.onOpen()
    this.onMessage(callback)
    this.onError()
    this.onClose()
  },
  // 发送数据
  send(data) {
    this.waitForConnection(() => {
      this.WS.send(JSON.stringify(data))
      // eslint-disable-next-line no-undef
      if (typeof callback !== 'undefined') callback()
    }, 1000)
  },
  // 发送器
  waitForConnection(callback, interval) {
    if (this.WS.readyState === 1) {
      callback()
    } else {
      setTimeout(() => {
        this.waitForConnection(callback, interval)
      }, interval)
    }
  },
  // 打开链接
  onOpen() {
    this.WS.onopen = () => {
      console.log('连接成功')
    }
  },
  // 接受数据
  onMessage(callback) {
    this.WS.onmessage = res => {
      try {
        if (res !== '欢迎detail加入连接！') {
          callback(JSON.parse(res.data))
        }
      } catch (e) {
        console.log('e: ', e)
      }
    }
  },
  // 接受失败回调
  onError() {
    this.WS.onerror = () => {
      console.log('连接错误，请刷新页面！')
    }
  },
  onClose() {
    this.WS.onclose = () => {
      console.log('关闭连接')
    }
  }
}

export default Socket
